<template>
  <div class="container_inner_main">
    <div style="display: flex;align-items: center">

      <div style="display: flex;align-items: center">
        <div class="simple_text">
          姓名:
        </div>
        <el-input v-model="checkInfo.userName" placeholder="请输入完整姓名" class="my-input"></el-input>

      </div>
      <div style="display: flex;align-items: center">
        <div class="simple_text">
          手机:
        </div>
        <el-input v-model="checkInfo.mobile" placeholder="请输入手机号" class="my-input"></el-input>
      </div>

      <div style="display: flex;align-items: center">
        <div class="simple_text">
          电话:
        </div>
        <el-input v-model="checkInfo.telephone" placeholder="请输入办公电话" class="my-input"></el-input>
      </div>

      <div style="display: flex;align-items: center">
        <div class="simple_text">
          部门:
        </div>
        <el-select v-model="checkInfo.dpId" placeholder="请选择部门" >
          <el-option
              class="style_select"
              v-for="item in departList"
              :key="item.id"
              :label="item.dpName?item.dpName:item.organs"
              :value="item.id">
            <span style="float: left" >{{ item.dpName }}</span>
            <span style="float: right; color: #8492a6; font-size: 11px">【{{ item.organs }}】</span>
          </el-option>
        </el-select>
      </div>

      <el-button type="primary" icon="el-icon-search" @click="checkInfo.currIndex =1,ritialInfo()" style="margin-left: 10px">搜索</el-button>
      <el-button icon="el-icon-delete" @click="clear">清空</el-button>

    </div>

    <div>
      <el-button type="primary" @click="clickToCreate">新增人员</el-button>
      <el-button type="success" @click="downloadFile">下载模板</el-button>
      <el-button type="success" @click="importVisible = true">导入人员</el-button>
      <el-button type="primary" @click="clickToDelete">已删除人员</el-button>
    </div>

    <el-table
        class="mtable"
        :data="personList"
        @row-click="onRowClick"
        border >
      <el-table-column min-width="5%" align="center"  property="sort" label="序号">
<!--        <template slot-scope="scope">-->
<!--          {{ personList.indexOf(scope.row) + 1 }}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column min-width="8%" property="userName" label="姓名"></el-table-column>
      <el-table-column min-width="10%" label="部门">
        <template slot-scope="scope">
          <div>
            {{getDetail(scope.row)}}
          </div>
        </template>
      </el-table-column>
      <el-table-column min-width="18%" property="job" label="职务"></el-table-column>
      <el-table-column min-width="11%" property="mobile" label="手机号"></el-table-column>
      <el-table-column min-width="9%" property="telephone" label="办公电话"></el-table-column>
      <el-table-column min-width="10%" property="whetherView" label="查看通讯录内容权限" :formatter="initView">
      </el-table-column>
      <el-table-column min-width="12%" property="whetherAccess" label="通讯录登录权限">
        <template slot-scope="scope">
          <el-switch
                  :disabled="userName != 'admin'"
                  :value="scope.row.whetherAccess"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeVisit(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column min-width="18%" align="center" label="操作" fixed="right">
        <template slot-scope="scope">
          <div>
            <el-button icon="el-icon-edit" type="text" @click="clickToEdit(scope.row)">修改</el-button>
            <el-button class="uni_btn" icon="el-icon-delete" type="text" @click="deleteUser(scope.row)">删除</el-button>
            <el-button v-if="scope.row.openid"  icon="el-icon-mobile-phone" type="text" @click="unBind(scope.row)" >解绑</el-button>
            <el-button icon="el-icon-sort" type="text" @click="clickToSort(scope.row)">排序</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination
        background
        layout="total, prev, pager, next"
        v-if="personList.length"
        :total="personTotal"
        @current-change="handleCurrentChange"
        :current-page=checkInfo.currIndex
        :page-size=checkInfo.pageSize
        style="text-align: center"
    >
    </el-pagination>

    <el-dialog
        :visible.sync="dialog_create"
        :title='currentDialogType'
        :lock-scroll="false"
        :close-on-click-modal="false">

      <div class="container_inner_dialog">
        <div style="display: flex;align-items: center">
          <div class="style_left_input">
            <span style="color: red">*</span>
            姓名
          </div>
          <el-input v-model="createInfo.userName" placeholder="请输入姓名" class="my-input"></el-input>

          <div class="style_left_input">
            <span style="color: red">*</span>
            手机号
          </div>
          <el-input v-model="createInfo.mobile" placeholder="请输入手机号" class="my-input"></el-input>
        </div>

<!--        <el-divider></el-divider>-->
        <div style="display: flex;align-items: center">
          <div class="style_left_input">办公电话</div>
          <el-input v-model="createInfo.telephone" placeholder="请输入办公电话" class="my-input"></el-input>


          <div class="style_left_input"><span style="color: red">*</span>部门</div>
          <el-select v-model="createInfo.dpId" class="my-input" placeholder="请选择部门">
            <el-option
                v-for="item in departList"
                :key="item.id"
                :label="item.dpName?item.dpName:item.organs"
                :value="item.id">
              <span style="float: left">{{ item.dpName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.organs }}</span>
            </el-option>
          </el-select>
        </div>

<!--        <el-divider></el-divider>-->


        <div style="display: flex;align-items: center">
          <div class="style_left_input_whole">职务</div>
          <el-input v-model="createInfo.job" placeholder="请输入职务" class="my-input"></el-input>
        </div>

        <div style="display: flex;align-items: center;margin-top: 10px;padding-bottom: 10px">
          <div class="style_left_input_whole" style="width: 25%;text-align: center" v-if="userName == 'admin'">查看通讯录内容权限</div>
          <el-radio-group v-model="createInfo.whetherView" v-if="userName == 'admin'">
            <el-radio :label="1">全部</el-radio>
            <el-radio :label="2">部分</el-radio>
            <el-radio :label="0">无</el-radio>
          </el-radio-group>
          <div class="style_left_input_whole" style="width: 20%;text-align: center">是否为领导</div>
          <el-radio-group v-model="createInfo.whetherLeader">
            <el-radio :label="'A'">是</el-radio>
            <el-radio :label="'B'">否</el-radio>
          </el-radio-group>
        </div>

        <div style="float: right">
          <el-button type="primary" @click="upload">保存</el-button>
          <el-button @click="cancelCreate">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
            title="导入人员"
            :visible.sync="importVisible"
            width="400px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="$refs.upload.clearFiles()"
            center>
      <el-upload
              ref="upload"
              action="/contacts/staff/parseExcel"
              :auto-upload="false"
              accept=".xlsx, .xls"
              :limit="1"
              :headers="uploadHeaders"
              :before-upload="beforeUpload"
              :on-exceed="handleExceed"
              :on-success="success"
              :on-error="err">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能导入xls、xlsx格式文件</div>
      </el-upload>
      <div style="text-align: right">
        <el-button type="primary" @click="uploadExcel">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
            :visible.sync="sortVisible"
            width="30%"
            :lock-scroll="false"
            title="排序"
            :close-on-click-modal="false">

      <div class="container_inner_dialog">

        <div style="display: flex;align-items: center">
          <div class="style_text_font">
            序号
          </div>
          <el-input v-model="sort" placeholder="请输入序号" class="my-input"  oninput="value=value.replace(/^0|[^0-9]/g,'')" ></el-input>
        </div>

        <div style="float: right">
          <el-button type="primary" @click="editSort">修改</el-button>
          <el-button @click="cancelSort">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
            :visible.sync="deleteVisible"
            :lock-scroll="false"
            title="已删除人员"
            :close-on-click-modal="false">

      <div class="container_inner_dialog">

        <div style="display: flex;align-items: center">
          <el-table
                  class="mtable"
                  :data="deletePerson"
                  @row-click="onRowClick"
                  border >
            <el-table-column min-width="5%" align="center"  label="序号">
                      <template slot-scope="scope">
                        {{ deletePerson.indexOf(scope.row) + 1 }}
                      </template>
            </el-table-column>
            <el-table-column min-width="8%" property="userName" label="姓名"></el-table-column>
            <el-table-column min-width="10%" label="部门">
              <template slot-scope="scope">
                <div>
                  {{getDetail(scope.row)}}
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="18%" property="job" label="职务"></el-table-column>
            <el-table-column min-width="12%" property="mobile" label="手机号"></el-table-column>
            <el-table-column min-width="9%" property="telephone" label="办公电话"></el-table-column>
            <el-table-column min-width="10%" align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <div>
                  <el-button icon="el-icon-edit" type="text" @click="clickToReset(scope.row)">复原</el-button>
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <el-pagination
                background
                layout="total, prev, pager, next"
                v-if="deletePerson.length"
                :total="deleteTotal"
                @current-change="handleDeleteChange"
                :current-page=deleteInfo.currIndex
                :page-size=deleteInfo.pageSize
                style="text-align: center"
        >
        </el-pagination>
        <div style="float: right">
<!--          <el-button type="primary" @click="editSort">修改</el-button>-->
<!--          <el-button @click="cancelDelete">取消</el-button>-->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addStaff,
  delStaff,
  getPartAllList,
  getStaffList,
  unbindStaff,
  updateStaff
} from "@/api/api";
import {Message} from "element-ui";
import {ssDateTimeFn} from "@/utils/time";

export default {
  name: "personmanager",
  data() {
    return {
      userName:localStorage.getItem('CurrentUser'),
      currentOrgans:localStorage.getItem('CurrentOrgans'),
      uploadHeaders:{'token':localStorage.getItem('token')},  //缓存里的token
      personList: [],
      deletePerson:[],
      departList: [],
      selectionList: [],
      personTotal:0,
      deleteTotal:0,
      checkInfo: {
        dpId: '',
        userName: '',
        mobile: '',
        telephone: '',
        currIndex: 1,
        pageSize: 8,
        status:1  ,
        whetherVisitor:0,
      },
      deleteInfo: {
        dpId: '',
        userName: '',
        mobile: '',
        telephone: '',
        currIndex: 1,
        pageSize: 2,
        status:0,
        whetherVisitor:0,
      },

      currentDialogType: '新增',

      importVisible:false,
      dialog_create: false,
      dialog_edit: false,
      sortVisible:false,
      deleteVisible:false,

      currentInfo: '',
      sort:null,
      createInfo: {
        dpId: '',
        job: '',
        userName: '',
        mobile: '',
        telephone: '',
        status: 1,
        createTime: '',
        createUser: '',
        whetherVisitor:0,
        whetherView:1,
        whetherLeader:'A',
        whetherAccess:1
      },

    }
  },
  created() {
    this.ritialBaseData();
    this.ritialInfo()
  },
  methods: {
    ritialBaseData() {
      this.departList = []
      let tempCheck = {
        organs:this.currentOrgans
      }
      getPartAllList(tempCheck).then(res => {
        if (res.data.code === '0000') {
          this.departList = res.data.data;
        }else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
        }
      })
    },
    ritialInfo() {
      this.personList = [];
      getStaffList(this.checkInfo).then(res => {
        if (res.data.code === '0000') {
          this.personTotal=res.data.data.total;
          this.personList = res.data.data.dataList;
        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },
    ritialDelete(){
      this.deletePerson = [];
      getStaffList(this.deleteInfo).then(res => {
        if (res.data.code === '0000') {
          this.deleteTotal=res.data.data.total;
          this.deletePerson = res.data.data.dataList;
          this.deleteVisible = true;
        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },
    clickToCreate() {
      this.currentDialogType = '新增'
      this.createInfo = {
        dpId: '',
        job: '',
        userName: '',
        mobile: '',
        telephone: '',
        status: 1,
        createTime: '',
        createUser: '',
        whetherVisitor:0,
        whetherView:1,
        whetherLeader:'A',
        whetherAccess:1
      }
      if(this.userName != 'admin'){
        this.createInfo.whetherView = 0;
        this.createInfo.whetherAccess = 0;
      }
      this.dialog_create = true

    },
    clickToEdit(row) {
      this.currentDialogType = '修改';
      this.currentInfo = row;
      this.createInfo = row;

      this.dialog_create = true

    },
    clickToSort(row){
      this.currentInfo = row;
      this.sort = row.sort;
      this.sortVisible = true;
    },
    clickToDelete(){
      this.deleteInfo = {
        dpId: '',
        userName: '',
        mobile: '',
        telephone: '',
        currIndex: 1,
        pageSize: 5,
        status:0,
        whetherVisitor:0,
      },
      this.ritialDelete();
    },
    clickToReset(row){
      row.status = 1;
      updateStaff(row).then(res=>{
        if (res.data.code === '0000') {
          Message.success(res.data.message);
          this.ritialDelete();
          this.ritialInfo();
        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },
    handleCurrentChange(val) {
      this.checkInfo.currIndex = val;
      this.ritialInfo()
    },
    handleDeleteChange(val){
      this.deleteInfo.currIndex = val;
      this.ritialDelete()
    },
    cancelCreate() {
      this.dialog_create = false
    },
    cancelEdit() {
      this.dialog_edit = false
    },
    cancelSort(){
      this.sortVisible = false
    },
    checkEmpty(val) {
      return val != null && val !== '' && val.length > 0
    },

    upload() {
      let mobileReg = /^1[3456789]\d{9}$/;
      if (this.currentDialogType === '修改'){
        this.modify()
      }else {
        if (!this.checkEmpty(this.createInfo.userName)) {
          this.$message.warning("请输入姓名")
          return
        }
        if (!this.checkEmpty(this.createInfo.mobile)) {
          this.$message.warning("请输入手机号")
          return
        }
        if (!mobileReg.test(this.createInfo.mobile)) {
          this.$message.warning("请输入正确的手机号")
          return
        }
        if (!this.createInfo.dpId) {
          this.$message.warning("请选择部门")
          return
        }
        let user=localStorage.getItem('CurrentUser');
        this.createInfo.createUser=user?user:'admin';
        this.createInfo.createTime=ssDateTimeFn(new Date())

        //上传 createInfo
        addStaff(this.createInfo).then(res=>{
          if (res.data.code === '0000') {
            Message.success(res.data.message);
            this.dialog_create=false;
            this.ritialInfo()

          } else {
            Message.warning(res.data.message);
            if (res.data.code==='10007'){
              this.$router.push('/login');
            }
            // Message.warning(res.data.message);
          }
        })
      }
    },
    editSort(){
      if (!this.checkEmpty(this.sort)) {
        this.$message.warning("请输入序号")
        return
      }
      this.currentInfo.sort = this.sort;
      updateStaff(this.currentInfo).then(res => {
        if (res.data.code === '0000') {
          Message.success(res.data.message);
          this.sortVisible = false;
          this.ritialInfo()
        }else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },
    downloadFile(){
      let a = document.createElement('a');
      // a.href = 'http://223.113.103.242:18093/contacts/file/通讯录模板.xlsx';
      a.href = '/contacts/file/通讯录模板.xlsx';
      // a.download = '通讯录模板.xlsx';
      a.click();
    },
    beforeUpload(file){
      // console.log(file)
    },
    //导入表格
    uploadExcel(){
      this.$refs.upload.submit();
      // this.init();
    },
    //校验导入
    handleExceed(files, fileList) {
      this.$message.warning(`当前只能上传 1 个文件`);
    },
    //导入成功后触发的方法
    success(response, file, fileList){
      if(response.success){
        this.$message.success('操作成功');
        this.importVisible = false;
      }else {
        this.$message.error(response.message);
        this.importVisible = false;
      }
      this.$refs.upload.clearFiles();
      this.ritialInfo();
      if(response.data != null && response.data != '' ){
        this.$alert(response.data, '错误提示', {
          confirmButtonText: '确定',
          // callback: action => {
          //   this.$message({
          //     type: 'info',
          //     message: `action: ${ action }`
          //   });
          // }
        });
      }

    },
    //导入失败后触发的方法
    err(err, file, fileList){
      this.$refs.upload.clearFiles();
      this.ritialInfo()
    },
    modify() {
      if (!this.checkEmpty(this.createInfo.userName)) {
        this.$message.warning("请输入姓名")
        return
      }
      if (!this.checkEmpty(this.createInfo.mobile)) {
        this.$message.warning("请输入手机号")
        return
      }

      //上传 createInfo
      updateStaff(this.createInfo).then(res=>{
        if (res.data.code === '0000') {
          Message.success(res.data.message);
          this.dialog_create=false
          this.ritialInfo()

        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },

    deleteUser(row) {
      this.currentInfo = row
      this.$confirm('此操作将删除' + this.currentInfo.userName + '，是否继续？', '删除人员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delStaff(this.currentInfo.id).then(res => {
              if (res.data.code === '0000') {
                this.ritialInfo()
                Message.success(res.data.message);
              } else {
                Message.warning(res.data.message);
                if (res.data.code==='10007'){
                  this.$router.push('/login');
                }
                // Message.warning(res.data.message);
              }
            }
        )
      }).catch(() => {

      })
    },
    unBind(row){
      this.currentInfo = row
      this.$confirm('此操作将解绑手机号【' + this.currentInfo.mobile + '】与微信小程序的绑定，是否继续？', '微信小程序解绑手机号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unbindStaff(this.currentInfo.id).then(res => {
              if (res.data.code === '0000') {
                this.ritialInfo()
                Message.success(res.data.message);
              } else {
                Message.warning(res.data.message);
                if (res.data.code==='10007'){
                  this.$router.push('/login');
                }
                // Message.warning(res.data.message);
              }
            }
        )
      }).catch(() => {

      })
    },
    onRowClick(row, event, colum) {
      this.currentInfo = row
    },

    clear() {
      this.checkInfo={
        dpId: '',
        userName: '',
        mobile: '',
        telephone: '',
        currIndex: 1,
        pageSize: 8,
        status:1  ,
        whetherVisitor:0,
      }
      this.ritialInfo()
    },
    changeView(row){
      this.$confirm('确定更改此用户的查看领导权限？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let status = JSON.parse(JSON.stringify(row));
        if(row.whetherView == 1){
          status.whetherView = 0
        }else{
          status.whetherView = 1
        }
        updateStaff(status).then(res=>{
          if (res.data.code === '0000') {
            if(row.whetherView == 1){
              row.whetherView = 0
            }else{
              row.whetherView = 1
            }
            Message.success(res.data.message);
            // this.dialog_create=false
            // this.ritialInfo()
          } else {
            Message.warning(res.data.message);
            if (res.data.code==='10007'){
              this.$router.push('/login');
            }
            // Message.warning(res.data.message);
          }
        })
        // unbindStaff(this.currentInfo.id).then(res => {
        //           if (res.data.code === '0000') {
        //             this.ritialInfo()
        //             Message.success(res.data.message);
        //           } else {
        //             Message.warning(res.data.message);
        //             if (res.data.code==='10007'){
        //               this.$router.push('/login');
        //             }
        //             // Message.warning(res.data.message);
        //           }
        //         }
        // )
      }).catch(() => {

      })
    },
    changeVisit(row){
      this.$confirm('确定更改此用户的通讯录登录权限？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let status = JSON.parse(JSON.stringify(row));
        if(row.whetherAccess == 1){
          status.whetherAccess = 0
        }else{
          status.whetherAccess = 1
        }
        updateStaff(status).then(res=>{
          if (res.data.code === '0000') {
            if(row.whetherAccess == 1){
              row.whetherAccess = 0
            }else{
              row.whetherAccess = 1
            }
            unbindStaff(row.id).then(res => {
                      if (res.data.code === '0000') {
                        this.ritialInfo()
                        Message.success(res.data.message);
                      } else {
                        Message.warning(res.data.message);
                        if (res.data.code==='10007'){
                          this.$router.push('/login');
                        }
                        // Message.warning(res.data.message);
                      }
                    }
            )
            // Message.success(res.data.message);
            // this.dialog_create=false
            // this.ritialInfo()
          } else {
            Message.warning(res.data.message);
            if (res.data.code==='10007'){
              this.$router.push('/login');
            }
            // Message.warning(res.data.message);
          }
        })

        // unbindStaff(this.currentInfo.id).then(res => {
        //           if (res.data.code === '0000') {
        //             this.ritialInfo()
        //             Message.success(res.data.message);
        //           } else {
        //             Message.warning(res.data.message);
        //             if (res.data.code==='10007'){
        //               this.$router.push('/login');
        //             }
        //             // Message.warning(res.data.message);
        //           }
        //         }
        // )
      }).catch(() => {

      })
    },
    initView(row, column, cellValue, index){
      if(cellValue == 0){
        return '无'
      }else if(cellValue == 1){
        return '全部'
      }else if(cellValue == 2){
        return '部分'
      }
    },
    getDetail(row){
      let organsName=''
      this.departList.forEach(item=>{
        if ((row.dpId+"")===(item.id+"")){
          organsName=item.organs;
        }
      })
      if (this.checkEmpty(row.dpName)){
        return organsName+"——"+row.dpName
      }
      return organsName
    }

  }
}
</script>

<style scoped>
.container_inner_main {

}

.mtable {
  font-size: 17px;
  margin: 20px 0;
  width: 95%;
}

.my-input {
  font-size: 17px;
  width: 100%;
  margin: 10px;
}

.container_inner_dialog {
  margin-bottom: 20px;
}

/deep/ .uni_btn.el-button--text {
  color: red !important;
}

.simple_text {
  font-size: 17px;
  text-align: center;
  margin: 0 5px;
  width: 90px;
}

.style_left_input {
  font-size: 17px;
  width: 200px;
  text-align: right
}



.style_left_input_whole {
  font-size: 17px;
  width: 83px;
  text-align: right
}

.style_top {
  width: 100%;
  text-align: right;
  margin-bottom: 10px;
}

.style_select{

}

/deep/.el-input{
  font-size: 17px;

}
/deep/.el-radio__label{
  font-size: 17px;
}
.style_text_font{
  font-size: 17px;
  width: 100px;
  text-align: right
}
</style>
